"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKinematicBody = exports.kinematicBodySchema = void 0;
var realms_engine_1 = require("realms-engine");
var realms_utils_1 = require("realms-utils");
exports.kinematicBodySchema = __assign(__assign({ applyMomentum: "function", applyVelocity: "function" }, realms_engine_1.positionableSchema), realms_engine_1.rotatableSchema);
exports.isKinematicBody = (0, realms_utils_1.isInterface)(exports.kinematicBodySchema);
